export default __webpack_public_path__ + "static/media/print.ad5af4db.svg";